import actions from './actions';

const {
  TODO_ADD_BEGIN,
  TODO_ADD_SUCCESS,
  TODO_ADD_ERR,

  TODO_READ_BEGIN,
  TODO_READ_SUCCESS,
  TODO_READ_ERR,
  
  TODO_UPDATE_BEGIN,
  TODO_UPDATE_SUCCESS,
  TODO_UPDATE_ERR,

  TODO_DELETE_BEGIN,
TODO_DELETE_SUCCESS,
TODO_DELETE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const TODOReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TODO_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TODO_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TODO_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const TODODeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TODO_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TODO_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TODO_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const TODOAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TODO_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TODO_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TODO_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

   
    default:
      return state;
  }
};

const TODOUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case TODO_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TODO_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TODO_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { TODOReducer, TODOUpdateReducer, TODOAddReducer, TODODeleteReducer };
